import React, { SyntheticEvent, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import Button from '@mui/material/Button'
import OrderAPI from 'api/orbitV1/OrderAPI'
import { AxiosError } from 'axios'
import AbstractTable from 'common/AbstractTable/StyledTable'
import PropTypes from 'prop-types'
import { OrderGetDataBase, ProvisionGetDataBase } from 'types/api/v1/order.type'

/** @returns {import('common/AbstractTable/AbstractTable').ColumnDef[]} */
const columnDefs = [
  {
    dataKey: 'msisdn',
    displayTitle: 'MSISDN'
  },
  {
    dataKey: 'iccid',
    displayTitle: 'ICCID'
  },
  {
    dataKey: 'status',
    displayTitle: 'Synced with BSSMW?',
    renderer: (rowData) => (rowData.status === 'DONE' ? 'YES' : 'NO')
  }
]

function SuggestedPairingsTable(props: SuggestedPairingsTableProps) {
  const [orderProvisioningList, setOrderProvisioningList] = useState<
    ProvisionGetDataBase[]
  >([])

  useEffect(() => {
    async function getOrderProvisioningList() {
      try {
        const provisionedItems = await OrderAPI.getProvisionedItemsForOrder(
          props.order.orderNo
        )

        if (provisionedItems) {
          setOrderProvisioningList(provisionedItems.data)
        }
      } catch (err) {
        const error = err as AxiosError
        toast.error(error.message)
      }
    }

    getOrderProvisioningList()
  }, [])

  return (
    <div>
      <AbstractTable
        name='Suggested Pairing'
        header={''}
        data={orderProvisioningList}
        columnDefs={columnDefs}
      />
      <Button
        onClick={(e) => {
          props.onConfirm(e)
        }}
      >
        Confirm Pairing
      </Button>
    </div>
  )
}

SuggestedPairingsTable.propTypes = {
  order: PropTypes.object,
  onConfirm: PropTypes.func
}

interface SuggestedPairingsTableProps {
  order: OrderGetDataBase
  onConfirm: (e: SyntheticEvent) => void
}

export default SuggestedPairingsTable
